import CommentReport from '@/models/CommentReport'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1
    },
    reportDetails: []
  },

  mutations: {
    setReportsList(state, reports) {
      each(reports, report => {
        const exist = find(state.list, { id: report.id })
        if (!exist) {
          state.list.push(new CommentReport(report))
        }
      })
    },

    clearReportsList(state) {
      state.list = []
    },

    setReportsListMeta(state, meta) {
      state.listMeta = meta
    },

    setReportDetails(state, report) {
      if (report instanceof CommentReport) {
        state.reportDetails = report
      } else {
        state.reportDetails = new CommentReport(report)
      }
    },

    clearReportDetails(state) {
      state.list = []
    }
  },

  actions: {
    async getReports({ commit }, params) {
      try {
        const query = CommentReport.page(params.page || 1)

        query.where('reportable_type', params.reportable_type)

        if (params.search) {
          query.where('search', params.search)
        }

        const res = await query
          .params({ limit: 20 })
          .include('reporter', 'reason')
          .get()

        commit('setReportsList', res.data)
        commit('setReportsListMeta', res.meta)
      } catch (error) {}
    },

    async getReportDetails({ commit }, reportId) {
      try {
        const { data } = await Api.get(
          `/admin/comment/report/${reportId}?include=reason,reporter,attachments`
        )

        commit('setReportDetails', data.data)
      } catch (error) {}
    },

    async blockComment({ commit }, payload) {
      try {
        await Api.post(`/admin/comment/${payload.id}/blocked`)
      } catch (error) {}
    },

    async unblockComment({ commit }, commentID) {
      await Api.post(`/admin/comment/${commentID}/blocked`)
    }
  }
}
